<template>
  <div class="faq">
    <v-header />
    <div class="faqCon">
      <div class="faqCon-header">
        <img src="./image/header.png" />
        <div class="faqCon-con">
          <div class="faqCon-left">
            <div class="faqCon-title">
              {{ faq.serve.title }}
              <img src="./image/dropDown.png" />
            </div>
            <a-collapse accordion :bordered="false">
              <a-collapse-panel
                v-for="(item, index) in faq.serve.list"
                :key="index"
                :header="item.title"
              >
                <div class="faq-aut" v-html="item.content"></div>
              </a-collapse-panel>
            </a-collapse>
          </div>
          <div class="faqCon-middle">
            <div class="faqCon-title">
              {{ faq.pice.title }}
              <img src="./image/dropDown.png" />
            </div>
            <a-collapse accordion :bordered="false">
              <a-collapse-panel
                v-for="(item, index) in faq.pice.list"
                :key="index"
                :header="item.title"
              >
                <div class="faq-aut" v-html="item.content"></div>
              </a-collapse-panel>
            </a-collapse>
          </div>
          <div class="faqCon-right" v-if="$i18n.locale === 'zh-CN'">
            <div class="faqCon-title">
              {{ faq.AandQ.title }}
              <img src="./image/dropDown.png" />
            </div>
            <a-collapse accordion :bordered="false">
              <a-collapse-panel
                v-for="(item, index) in faq.AandQ.list"
                :key="index"
                :header="item.title"
              >
                <div class="faq-aut" v-html="item.content"></div>
              </a-collapse-panel>
            </a-collapse>
          </div>
          <div class="faqCon-right" v-if="$i18n.locale === 'en-US'"></div>
        </div>
      </div>
    </div>
    <v-footer />
  </div>
</template>
<script>
import Header from '../home/components/header.vue';
import Footer from '../home/components/footer.vue';
export default {
  data() {
    return {
      faq: {},
      faqCN: {
        serve: {
          title: '验货服务常见问答',
          list: [
            {
              title: '此网站提供哪些服务',
              content: `<p>本网站是曼德品控的官方网站，主要提供两大块服务。</p>
                <p>1.为客户提供货品出货前的品质检验,出货装运监管服务。</p>
                <p>2.为客户提供供应商资质审查服务。</p>`,
            },
            {
              title: '曼德相较竞争对手有哪些优势?',
              content: `<p>曼德品控服务相较于竞争对手，主要优势：</p>
                <p>1. 曼德深耕制造业品控体系，通过长期的用户需求研究，对贸易商，出口商的品质痛点做出重点关注。</p>
                <p>2. 我们在审查过程中重视数据收集，每一个模块都有具体数据支撑，眼见为实。 量化报告，重点清晰易读。</p>
                <p>3. 曼德提供优质服务的同时，保持高竞争力的价格。同时套餐客户享有折上折。</p>`,
            },
            {
              title: '曼德如何确定品控人员的专业性?',
              content: `<p>曼德的品控人员有相当部分来自权威第三方质检公司。曼德对QC 实行严格的认证制度。要求QC
                提交一系列资料包括专门产品范畴的技能证书等。同时QC需要用我司的系统进行 Test Inspection.
                曼德会审核QC的报告出品，并对QC进行培训，让其适应我司的检测规范。</p>`,
            },
            {
              title: '曼德如何保证每批验货的有效性与掌控每次QC服务的质量？',
              content: `<p>曼德执行严格的行业/国家标准，在每次执行检测任务时， QC将会提前1-2天确认客户的货品以及
                特别要求，测试项目等信息。在QC 现场检验时，曼德运营后台能够实时同步QC移动端上传的检测
                照片以及测量数据。 我司质检工程师会对其上传的数据进行实时审查，并且及时纠正遗漏或不规范
                的记录。以此保证每份报告详实，标准的出品。</p>`,
            },
          ],
        },
        pice: {
          title: '价格与支付常见问答',
          list: [
            {
              title: '订单价格如何核算？',
              content: `<p>曼德的服务价格以人/天（MD）为单位。客户在新建订单时会看到对应服务的标准单价（1MD）
                。根据客户提交的订单资料，曼德会联系客户针对验货细节进行核实并对不同的订单进行报价。因
                而不同的订单可能会有不同的价格。</p>`,
            },
            {
              title: '可以使用哪些支付方式?',
              content: `<p>目前订单支付支持RMB 或 USD 双币种支付。</p>
                <p>支持的支付方式包括：</p>
                <p>1. 曼德钱包余额</p>
                <p>2. 套餐余额</p>
                <p>3. 支付宝扫码</p>
                <p>4. 微信扫码</p>
                <p>5. PayPal</p>
                <p>6. 线下银行转账</p>
                `,
            },
            {
              title: '支持取消订单吗？',
              content: `<p>支持。</p>
                <p>在未履行服务前，客户有权取消订单。如需取消订单，请至“我的订单”中进行操作。也可联系您
                的专属客户经理进行处理。</p>`,
            },
            {
              title: '如何开发票？',
              content: `<p>曼德服务费用支持开票（增值税普通发票或专用发票），开票需要客户承担开票手续费。（服务费
                用的6%）</p>`,
            },
          ],
        },
        AandQ: {
          title: '售后服务常见问题',
          list: [
            {
              title: '对服务有异议，如何发起售后？',
              content: `<p>曼德重视客户的售后服务质量，客户如对服务过程或服务质量产生异议，可以联系曼德售后团队。
                客户将能够从售后团队获取帮助。请至信 service@minderwork.com
                您亦可联系您的专属客户经理取得帮助。 </p>`,
            },
          ],
        },
      },
      faqUS: {
        serve: {
          title: 'Services',
          list: [
            {
              title: 'What services can I get from Minder?',
              content: `<p>Minder provides inspection services, There are 3 major services: Products Inspection,
                Loading Supervision, Vendor Assessment. please refer to the service pages for details.</p>`,
            },
            {
              title: 'What is the biggest advantages?',
              content: `
                <p>1. Minder focused on the quality control system. we studied a lot of customers including
                  trade agents and importers. We know what you care about your goods.</p>
                <p>2. With our integrated data collect system, our quality engineers get you the most important figures and these data will be shown clearly in our report which makes the report easy to read.</p>
                <p>3. Minder provides high competitive price and you save more with our Plan.</p>`,
            },
            {
              title: 'How to use the order system?',
              content: `
                <p>1. Sign up & Sign in</p>
                <p>2. Select the service you want. fill in all the information required to create the order.</p>
                <p>3. Our Account Manager will contact you to confirm the order and price.</p>
                <p>4. Finish the Payment.</p>
                <p>5. Minder Quality engineer will do the on-site inspection.</p>
                <p>6. You are able to view & download the report via the order system.</p>
              `,
            },
          ],
        },
        pice: {
          title: 'Price & Payment',
          list: [
            {
              title: 'What is the price?',
              content: `<p>Minder services is caculated in M/D. Our Account Manager will contact you to quote you
                the Price in M/D after the order is created in our system. Please refer to the unit price
                which will be shown on the order system.</p>`,
            },
            {
              title: 'How can I finish the payment?',
              content: `<p>You can Pay either in RMB or USD</p>
                <p>Payment methods:</p>
                <p>1. Minder wallet </p>
                <p>2. Minder Plan </p>
                <p>3. AliPay</p>
                <p>4. WeChat Pay</p>
                <p>5. PayPal</p>
                <p>6. Bank Transfer</p>
                `,
            },
            {
              title: 'Can I cancel the Order in specific case?',
              content: `<p>Yes, you can.</p>
                <p>If by any chance you input the incorrected order information, you can cancel the order.
                  (Before the Due Date)</p>`,
            },
          ],
        },
        AandQ: {
          title: '',
          list: [],
        },
      },
    };
  },
  created() {
    if (this.$i18n.locale === 'zh-CN') {
      this.faq = this.faqCN;
    } else if (this.$i18n.locale === 'en-US') {
      this.faq = this.faqUS;
    }
  },
  computed: {
    language: function() {
      return this.$i18n.locale;
    },
  },
  watch: {
    language: function() {
      if (this.$i18n.locale === 'zh-CN') {
        this.faq = this.faqCN;
      } else if (this.$i18n.locale === 'en-US') {
        this.faq = this.faqUS;
      }
    },
  },
  components: {
    'v-header': Header,
    'v-footer': Footer,
  },
};
</script>
<style lang="less">
.faq {
  .faqCon {
    .faqCon-header {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .faqCon-con {
      min-height: 500px;
      text-align: left;
      display: flex;
      width: 73%;
      margin: 0 auto;
      .faqCon-title {
        margin: 20px 0 10px 40px;
        border: 1px solid #d9d9d9;
        display: inline-block;
        padding: 5px 10px;
        font-size: 16px;
        box-shadow: 0 0 2px 0px #999 inset;
        img {
          width: 24px;
          height: 24px;
        }
      }
      > div {
        width: 33%;
        margin: 0 10px;
        p {
          margin-bottom: 3px;
          font-size: 14px;
        }
        .faq-aut {
          margin-left: 24px;
        }
        .ant-collapse-header {
          font-weight: 600;
        }
      }
    }
  }
}
</style>
